"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqual = exports.toArray = exports.isRegExp = exports.isObj = exports.isNum = exports.isBool = exports.isStr = exports.isPlainObj = exports.isArr = exports.isFn = void 0;
var isType = function (type) { return function (obj) {
    return obj != null && Object.prototype.toString.call(obj) === "[object " + type + "]";
}; };
exports.isFn = isType('Function');
exports.isArr = Array.isArray || isType('Array');
exports.isPlainObj = isType('Object');
exports.isStr = isType('String');
exports.isBool = isType('Boolean');
exports.isNum = isType('Number');
exports.isObj = function (val) { return typeof val === 'object'; };
exports.isRegExp = isType('RegExp');
var isArray = exports.isArr;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
exports.toArray = function (val) { return Array.isArray(val) ? val : val !== undefined ? [val] : []; };
exports.isEqual = function (a, b) {
    if (a === b) {
        return true;
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        var arrA = isArray(a);
        var arrB = isArray(b);
        var i = void 0;
        var length_1;
        var key = void 0;
        if (arrA && arrB) {
            length_1 = a.length;
            if (length_1 !== b.length) {
                return false;
            }
            for (i = length_1; i-- !== 0;) {
                if (!exports.isEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        if (arrA !== arrB) {
            return false;
        }
        var keys = keyList(a);
        length_1 = keys.length;
        if (length_1 !== keyList(b).length) {
            return false;
        }
        for (i = length_1; i-- !== 0;) {
            if (!hasProp.call(b, keys[i])) {
                return false;
            }
        }
        for (i = length_1; i-- !== 0;) {
            key = keys[i];
            if (!exports.isEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return a !== a && b !== b;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/cool-path/lib/utils.js
// module id = 1501
// module chunks = 0